var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26C25.1046 26 26 25.1046 26 24C26 22.8954 25.1046 22 24 22C22.8954 22 22 22.8954 22 24C22 25.1046 22.8954 26 24 26Z",
    stroke: "#CBCBCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 29.9987C17.3333 24.0276 17.3333 21.042 19.1882 19.187C21.0432 17.332 24.0288 17.332 29.9999 17.332C35.971 17.332 38.9566 17.332 40.8117 19.187C42.6666 21.042 42.6666 24.0276 42.6666 29.9987C42.6666 35.9698 42.6666 38.9554 40.8117 40.8104C38.9566 42.6654 35.971 42.6654 29.9999 42.6654C24.0288 42.6654 21.0432 42.6654 19.1882 40.8104C17.3333 38.9554 17.3333 35.9698 17.3333 29.9987Z",
    stroke: "#CBCBCB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 41.9999C26.4967 35.0333 33.0322 25.8453 42.6634 32.0565",
    stroke: "#CBCBCB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholder-img.a32bfd2e0e4f5d5f065ee6b500c8f9a9.svg";
export { ForwardRef as ReactComponent };